import React from 'react';
import type ListWorkflows from '@jira/admin-pages__list-workflows/src/ListWorkflows.tsx';
import { markAsProductBundleReady } from '@atlassian/jira-spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@atlassian/jira-spa/src/view/lazy-page/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

export const LazyListWorkflows = lazyForPaint<typeof ListWorkflows>(() =>
	markAsProductBundleReady(
		import(
			/* webpackChunkName: "async-admin-pages-list-workflows", jiraSpaEntry: "async-admin-pages-list-workflows" */ '@jira/admin-pages__list-workflows/src/ListWorkflows.tsx'
		),
	),
);

const AsyncListWorkflows = (): React.JSX.Element => (
	<LazyPage Page={LazyListWorkflows} pageId="jira-admin-pages-list-workflows" shouldShowSpinner />
);

export default AsyncListWorkflows;
